import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import Vue from "vue";
export default {
  install(Vue) {
    Vue.directive("fixedScroll", {
      bind(el) {
        el._fixedScrollHandler = null;
        initFixedScroll(el);
      },
      componentUpdated(el) {
        initFixedScroll(el);
      },
      unbind(el) {
        cleanup(el);
      }
    });
  }
};
function initFixedScroll(el) {
  // 清理旧事件监听器
  cleanup(el);

  // 使用双层nextTick确保DOM更新完成
  Vue.nextTick(() => {
    Vue.nextTick(() => {
      const fixedWrappers = el.querySelectorAll(".el-table__fixed-body-wrapper");
      fixedWrappers.forEach(wrapper => {
        // 添加新事件监听
        const handler = createScrollHandler(el);
        wrapper.addEventListener("wheel", handler, {
          passive: false
        });
        el._fixedScrollHandler = handler;
      });
    });
  });
}
function createScrollHandler(el) {
  return function (e) {
    e.stopPropagation();
    const bodyWrapper = el.querySelector(".el-table__body-wrapper");
    if (bodyWrapper) {
      bodyWrapper.scrollTop += e.deltaY;
    }
  };
}
function cleanup(el) {
  if (el._fixedScrollHandler) {
    const fixedWrappers = el.querySelectorAll(".el-table__fixed-body-wrapper");
    fixedWrappers.forEach(wrapper => {
      wrapper.removeEventListener("wheel", el._fixedScrollHandler);
    });
    el._fixedScrollHandler = null;
  }
}